<template>
	<div class="changeChip" :class="{ 'ac-bg-black': ac }">
		<header-component
			:is-soon="false"
			img-left="/trocachip/img/setinha-left-white.svg"
			img-right="/trocachip/img/access-white.svg"
			class="header-component"
            :backRoute="true"
			:progression="false"
		/>
		<div class="change_chip_container">
			<h2 class="changeChip_title" :class="{ 'ac-color-white': ac }" v-html="changeChipReasonPage.title"></h2>
			<div class="changeChip_subtitle">
				<p v-html="changeChipReasonPage.subtitle"></p>
			</div>
			<div class="description_chip">
				<div class="info_description" v-for="(benefit, index) of changeChipReasonPage.benefits" :key="index">
					<img src="/trocachip/img/Path2.svg" alt="shutdown-wifi" title="nowifi" />
					<span class="description_name" v-html="benefit"></span>
				</div>
            </div>			
		</div>
		<footer class="changeChip_container-button" >
			<button
				class="changeChip_button"
				@click="nextFlow(changeChipReasonPage.firstButton.flow)"
				:class="{ 'ac-border-yellow': ac, 'ac-color-yellow': ac }"
			>
				{{ changeChipReasonPage.firstButton.text }}
			</button>
			<button
				class="changeChip_button"
				@click="nextFlow(changeChipReasonPage.secondButton.flow)"
				:class="{ 'ac-border-yellow': ac, 'ac-color-yellow': ac }"
				
			>
				{{ changeChipReasonPage.secondButton.text }}
			</button>
		</footer>
	</div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent';
import { mapState } from 'vuex';

export default {
    name: 'changeChip',
    components: {
        HeaderComponent,
    },
    data() {
        return {			
            description: '',
            // goToLastRoute: goToLastRoute
        };
    },
    computed: mapState({
        ac: (state) => state.ac,
        document: (state) => state.document,
        config: (state) => state.config,
        customer: (state) => state.customer,
        initFlow: (state) => state.config['init_flow'],
        changeChipReasonPage: (state) => state.config.changeChipReasonPage || {}
		
    }),
    methods: {
        nextFlow(flowSelected) {
            this.$store.commit("flowSelected", flowSelected);
            this.$router.push({ name: 'documents' });
        }		
    },
};

</script>

<style lang="scss">
.changeChip {
	width: 100%;
	height: 100%;
	display: block;
	position: absolute;
	background: #003091;
    .change_chip_container {
        width: 90%;
        height: auto;
        margin: 0 5%;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: content-box;
    }
	.changeChip_title {
		width: 309px;
		height: auto;
		font-family: 'timsans_thin';
		display: block;
        margin-block-end: 0 !important;
		margin-top: 96px;
		font-size: 32px;
		font-weight: 300;
		line-height: 39.36px;
		text-align: center;
		color: #FFFFFF;
	}
	.changeChip_container-button {
		width: 100%;
		height: auto;
		margin-top: 28px;
		position: fixed;
		bottom: 0;
		justify-content: center;
		display: grid;
		align-items: center;
		background: #003091;
	}
	.changeChip_button {
		width: 286px;
		height: 52px;
		margin: 0 auto 24px auto;
		border-radius: 26px;
		border: solid 1px #FFFFFF;
		background: none;
		outline: none;
		font-size: 1em;
		text-align: center;
		color: #FFFFFF;
		&:hover {
			cursor: pointer;
			-webkit-box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
			-moz-box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
			box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
			transition: 1s;
		}
	}
	.description_chip {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-left: 27px;
	}
	.description_name {
		margin-top: 0 !important;
		padding-left: 18px;
		width: 250px;
		align-items: center;
	}
	.info_description {
		padding-bottom: 24px;
		font-family: "timsans_regular";
		font-size: 16px;
		font-weight: 400;
		line-height: 24px;
		letter-spacing: -0.20000000298023224px;
		display: flex;
		justify-content: center;
		align-content: center;
		align-items: center;
		vertical-align: middle;
		width: 270px;
		float: left;
		color: #ffffff;
	}	
	.changeChip_subtitle {
		width: 238px;
		min-height: 48px;
		margin: 16px auto 23px auto;
		display: block;
		position: relative;
		> p {
			width: 238px;
			height: 48px;
			font-family: 'timsans_regular';
			font-size: 16px;
			font-weight: normal;
			font-stretch: normal;
			font-style: normal;
			line-height: 24px;
			letter-spacing: normal;
			text-align: center;
			color: #ffffff;
			opacity: 60%;
		}
	}
}
@media (min-width: 768px) {
	.changeChip {
		width: 100%;
		height: 100%;
		display: grid;
		grid-auto-columns: 50% 50%;
		grid-template-areas:
			'header header'
			'container background';
		position: absolute;
		.header-component {
			width: 45%;
			grid-area: header;
		}
		.change_chip_container {
			grid-area: container;
			.changeChip_title {
				width: 416px;
				height: auto;
				display: block;
				margin: 115px auto 0 auto;
				font-family: 'timsans_thin';
				font-size: 2em;
				font-weight: normal;
				line-height: 1.2;
			}
			.changeChip_container-button {
				width: 100%;
				height: auto;
				margin-top: 72px;
				display: block;
				display: grid;
				align-items: center;
				.changeChip_button {
					width: 320px;
					height: 52px;
					margin: 0 auto 32px auto;
					border-radius: 26px;
					font-size: 1em;
				}
			}
		}
	}
}
@media (min-width: 960px) {
	.changeChip {
		width: 100%;
		height: 100%;
		display: grid;
		grid-auto-columns: 50% 50%;
		grid-template-areas:
			'header header'
			'container background';
		position: absolute;
		.header-component {
			width: 45%;
			grid-area: header;
		}
		.change_chip_container {
			grid-area: container;
			.changeChip_title {
				width: 416px;
				height: auto;
				display: block;
				margin: 115px auto 0 auto;
				font-family: 'timsans_thin';
				font-size: 2em;
				font-weight: normal;
				line-height: 1.2;
			}
			.changeChip_container-button {
				width: 100%;
				height: auto;
				margin-top: 72px;
				display: block;
				display: grid;
				align-items: center;
				.changeChip_button {
					width: 320px;
					height: 52px;
					margin: 0 auto 32px auto;
					border-radius: 26px;
					font-size: 1em;
				}
			}
		}
	}
}
</style>
